import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-2 lg:px-0" }
const _hoisted_2 = { class: "py-12 lg:container lg:mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-1 gap-12 lg:grid-cols-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "mb-4" }, "Faucet")
  ])
], -1)

import FaucetTable from '@/components/tables/FaucetTable/FaucetTable.vue';

export default _defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(FaucetTable)
    ])
  ]))
}
}

})